module.exports = __webpack_public_path__ + "static/media/looking-out-of-window.b21e921e.png";